import React from 'react';
import { Badge, Button, Form, Navbar } from 'react-bootstrap';
import { ExclamationDiamondFill, InfoCircleFill } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { getAxiosErrorResponse } from '../../api/utils';

import { AuthenticatedContextConsumer } from '../../context/AuthenticatedContext';
import { pageTitle } from '../../context/PageRecoil';

const Header: React.FunctionComponent = () => {
  const history = useHistory();
  const [isDisabled, setIsDisabled] = React.useState(false);
  const hrefMenu = history.createHref({ pathname: '/menu' });
  const title = useRecoilValue(pageTitle);
  return (
    <AuthenticatedContextConsumer>
      {({ isAuthenticated, loginCustomer, logout }) => {
        return (
          <Navbar className="bg-Unknown justify-content-between" variant="dark">
            <div
              // 幅を小さくしたときの改行防止
              style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'nowrap',
              }}
            >
              {/* 画面のヘッダとログイン画面とそれ以外でタイトル表示を分岐 */}
              {title.pageTitle === 'login' ? (
                <Navbar.Brand>設備情報管理Cloudシステム</Navbar.Brand>
              ) : (
                <>
                  <Navbar.Brand href={hrefMenu}>
                    設備情報管理Cloudシステム
                  </Navbar.Brand>
                  <Navbar.Brand>|</Navbar.Brand>
                  <Navbar.Brand>{title.pageTitle}</Navbar.Brand>
                </>
              )}
            </div>
            {isAuthenticated ? (
              <Form
                className="d-none d-md-flex"
                inline
                onSubmit={(event) => {
                  event.preventDefault();
                  setIsDisabled(true);
                  logout()
                    .then((res) => {
                      setIsDisabled(false);
                      history.push('/login');
                      toast.success(
                        () => (
                          <>
                            <InfoCircleFill />
                            <span>{' ログアウト成功'}</span>
                          </>
                        ),
                        {
                          autoClose: 3000,
                          // onClose: () => history.push('/login'),
                        },
                      );
                      return res;
                    })
                    .catch((error) => {
                      const res = getAxiosErrorResponse(error);
                      toast.error(() => {
                        return (
                          <>
                            <ExclamationDiamondFill />
                            <span>{` ログアウト失敗`}</span>
                            <small>{` (${res?.status ?? '応答なし'})`}</small>
                          </>
                        );
                      });
                      setIsDisabled(false);
                    });
                }}
              >
                <Badge className="mx-1" variant="light">
                  {loginCustomer?.customerName}
                </Badge>
                <Badge className="mx-1" variant="light" pill>
                  {loginCustomer?.customerOfficeName}
                </Badge>
                <Button className="mx-1" type="submit" disabled={isDisabled}>
                  ログアウト
                </Button>
              </Form>
            ) : (
              <></>
            )}
          </Navbar>
        );
      }}
    </AuthenticatedContextConsumer>
  );
};

export default Header;
